import { Injectable } from '@angular/core';
import { ChargingIntroductionMapper } from './introduction.mapper';
import { ChargingIntroductionModel, IntroductionType } from './introduction.model';

@Injectable()
export class ChargingIntroductionService {
  constructor(private mapper: ChargingIntroductionMapper) {}

  public getModel(type: IntroductionType): ChargingIntroductionModel {
    return this.mapper.map(type);
  }
}
